import type { IntentCaptureRequest } from '$/requests/IntentCapture.ts';

export type CommonIntakeCaptureSnapshot = {
  issue_title?: string;
  short_description?: string;
  core_constraints?: string[];
  core_constraint_detail?: string;
  decision_needed?: string;
  visibility?: string[];
  impact?: string[];
  time_sensitivity?: string;
};

function joinList(values: string[] | undefined): string {
  return (values ?? []).filter(Boolean).join(',');
}

export function buildIntentCapture(data: CommonIntakeCaptureSnapshot): IntentCaptureRequest {
  const issue_title = data.issue_title?.trim() ?? '';
  const issue_text = data.short_description?.trim() ?? '';
  const core_constraint = joinList(data.core_constraints);
  const decision_required = data.decision_needed?.trim() ?? '';

  if (!issue_title || !issue_text || !core_constraint || !decision_required) {
    throw new Error('Issue title, description, core constraints, and decision are required');
  }

  return {
    issue_title,
    issue_text,
    core_constraint,
    core_constraint_other: data.core_constraint_detail?.trim() || null,
    decision_required,
    issue_visibility: data.visibility ?? [],
    impact_if_unresolved: data.impact ?? [],
    time_sensitivity: data.time_sensitivity?.trim() ?? '',
  };
}
